// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5656":"c3a71a48","6375":"98906430"}[chunkId] + ".chunk.css";
};